"use strict";
// @ts-nocheck
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mock_L2_xDaiBridge__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_chainId",
                type: "uint256",
            },
            {
                internalType: "contract IArbitraryMessageBridge",
                name: "messenger",
                type: "address",
            },
            {
                internalType: "address",
                name: "l1Governance",
                type: "address",
            },
            {
                internalType: "contract HopBridgeToken",
                name: "hToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "l1BridgeAddress",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "activeChainIds",
                type: "uint256[]",
            },
            {
                internalType: "address[]",
                name: "bonders",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "l1ChainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "defaultGasLimit",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newBonder",
                type: "address",
            },
        ],
        name: "BonderAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousBonder",
                type: "address",
            },
        ],
        name: "BonderRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalBondsSettled",
                type: "uint256",
            },
        ],
        name: "MultipleWithdrawalsSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Stake",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "relayer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "relayerFee",
                type: "uint256",
            },
        ],
        name: "TransferFromL1Completed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
        ],
        name: "TransferRootSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "transferNonce",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bonderFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "TransferSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rootCommittedAt",
                type: "uint256",
            },
        ],
        name: "TransfersCommitted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Unstake",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
        ],
        name: "WithdrawalBondSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "WithdrawalBonded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "transferNonce",
                type: "bytes32",
            },
        ],
        name: "Withdrew",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "activeChainIds",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "chainIds",
                type: "uint256[]",
            },
        ],
        name: "addActiveChainIds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
        ],
        name: "addBonder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "ammWrapper",
        outputs: [
            {
                internalType: "contract L2_AmmWrapper",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "transferNonce",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "bonderFee",
                type: "uint256",
            },
        ],
        name: "bondWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "transferNonce",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "bonderFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "bondWithdrawalAndDistribute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
        ],
        name: "commitTransfers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultGasLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "relayer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "relayerFee",
                type: "uint256",
            },
        ],
        name: "distribute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
        ],
        name: "getBondedWithdrawalAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
        ],
        name: "getCredit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
        ],
        name: "getDebitAndAdditionalDebit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "maybeBonder",
                type: "address",
            },
        ],
        name: "getIsBonder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getNextTransferNonce",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
        ],
        name: "getRawDebit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "transferNonce",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "bonderFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "getTransferId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
        ],
        name: "getTransferRoot",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "total",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountWithdrawn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "createdAt",
                        type: "uint256",
                    },
                ],
                internalType: "struct Bridge.TransferRoot",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
        ],
        name: "getTransferRootId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "hToken",
        outputs: [
            {
                internalType: "contract HopBridgeToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
        ],
        name: "isTransferIdSpent",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "l1BridgeAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "l1BridgeCaller",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "l1ChainId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "l1Governance",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "lastCommitTimeForChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxPendingTransfers",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "messenger",
        outputs: [
            {
                internalType: "contract IArbitraryMessageBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minBonderBps",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minBonderFeeAbsolute",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumForceCommitDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "pendingAmountForChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "pendingTransferIdsForChainId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "chainIds",
                type: "uint256[]",
            },
        ],
        name: "removeActiveChainIds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
        ],
        name: "removeBonder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "originalAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "rescueTransferRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bonderFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract L2_AmmWrapper",
                name: "_ammWrapper",
                type: "address",
            },
        ],
        name: "setAmmWrapper",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_defaultGasLimit",
                type: "uint256",
            },
        ],
        name: "setDefaultGasLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "setHopBridgeTokenOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_l1BridgeAddress",
                type: "address",
            },
        ],
        name: "setL1BridgeAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_l1BridgeCaller",
                type: "address",
            },
        ],
        name: "setL1BridgeCaller",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_l1Governance",
                type: "address",
            },
        ],
        name: "setL1Governance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxPendingTransfers",
                type: "uint256",
            },
        ],
        name: "setMaxPendingTransfers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IArbitraryMessageBridge",
                name: "_messenger",
                type: "address",
            },
        ],
        name: "setMessenger",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minBonderBps",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_minBonderFeeAbsolute",
                type: "uint256",
            },
        ],
        name: "setMinimumBonderFeeRequirements",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minimumForceCommitDelay",
                type: "uint256",
            },
        ],
        name: "setMinimumForceCommitDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
        ],
        name: "setTransferRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "transferRootTotalAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "transferIdTreeIndex",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "siblings",
                type: "bytes32[]",
            },
            {
                internalType: "uint256",
                name: "totalLeaves",
                type: "uint256",
            },
        ],
        name: "settleBondedWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                internalType: "bytes32[]",
                name: "transferIds",
                type: "bytes32[]",
            },
            {
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
        ],
        name: "settleBondedWithdrawals",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "transferNonceIncrementer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "unstake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "transferNonce",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "bonderFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "rootHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "transferRootTotalAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "transferIdTreeIndex",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "siblings",
                type: "bytes32[]",
            },
            {
                internalType: "uint256",
                name: "totalLeaves",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class Mock_L2_xDaiBridge__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Mock_L2_xDaiBridge__factory = Mock_L2_xDaiBridge__factory;
Mock_L2_xDaiBridge__factory.abi = _abi;
